import React from 'react';
import { useTranslation } from 'react-i18next';
import { AgencyHeader } from '../AgencyHeader';
import { AgencyContactsSection } from '../AgencyContactsSection';
import { SelectedAgencyQuery } from '../../../graphql/graphql';
import { PhoneButtonClickHandler } from '../../Ad/BottomPhoneButton/types';
import {
  AgencyInfoBlockWrapper,
  AgencyInfoContent,
  TopCoverImg
} from './styled';

interface AgencyInfoBlockProps {
  agencyData: NonNullable<SelectedAgencyQuery['agency']>;
  phonesShown: string[] | null;
  isVisible: boolean;
  h1: string | null;
  setIsVisible: (v: boolean) => void;
  onClickHandler: PhoneButtonClickHandler;
}

export const AgencyInfoBlock: React.FC<AgencyInfoBlockProps> = ({
  agencyData,
  isVisible,
  phonesShown,
  h1,
  setIsVisible,
  onClickHandler
}) => {
  const { t } = useTranslation();

  const city = agencyData.city.name
    ? t('pages.agency.city', { city: agencyData.city.name })
    : '';
  const displayedAddress = agencyData.contactAddress
    ? `${city}${agencyData.contactAddress}`
    : '';

  return (
    <AgencyInfoBlockWrapper>
      {agencyData.coverUrl && (
        <TopCoverImg
          src={agencyData.coverUrl}
          data-cy="top-cover-img"
          alt={t('pages.agency.title', { name: agencyData.name })}
          width={375}
          height={100}
        />
      )}
      <AgencyInfoContent>
        <AgencyHeader
          apartmentCount={agencyData.itemsCount}
          title={agencyData.name}
          views={agencyData.viewsCount}
          logoUrl={agencyData.logoUrl}
          description={agencyData.description}
          h1={h1}
        />
        <AgencyContactsSection
          address={displayedAddress}
          lat={agencyData.latitude}
          lng={agencyData.longitude}
          timetable={agencyData.schedule}
          phonesShown={phonesShown}
          phonesMasked={agencyData.phonesMasked || []}
          isVisible={isVisible}
          clickHandler={onClickHandler}
          setIsVisible={setIsVisible}
        />
      </AgencyInfoContent>
    </AgencyInfoBlockWrapper>
  );
};
